export default __webpack_public_path__ + "static/usa-flag-7b2cd75957dfa5c0b1d07cc1c5b6dab3.svg";